import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '=',
        sites: '='
    },
    template: `
    <div class="col00">
        <div class="heading01 type01">
            <h1>{{ 'budget.Budget' | translate }}</h1>index.js
        </div>
        <reports-budget-filter filter-overview="vm.filterOverview" sites="vm.sites" classifiers="vm.classifiers" filter="vm.filter" list="vm.list" default-filter="vm.defaultFilter"/>
        <div class="well">
            <h2>{{ 'budget.Report' | translate }}</h2>
            <reports-filter-overview filter-overview="vm.filterOverview"></reports-filter-overview>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <div class="" ng-if="!vm.list.loading && vm.list.items.length">
                <table class="data01" datatable="ng" dt-options="vm.DATATABLES">
                    <thead>
                        <tr>
                            <th>{{ 'reports.Department' | translate }}</th>
                            <th>{{ 'reports.Employees' | translate }}</th>
                            <th>{{ 'reports.Budget' | translate }}<small>{{ 'reports.Per employee' | translate }}</small></th>
                            <th>{{ 'reports.Planned' | translate }}</th>
                            <th>{{ 'reports.Spent' | translate }}</th>
                            <th>{{ 'reports.Total' | translate }}</th>
                            <th class="none dt-hide"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="classifierBudget in vm.list.items">
                            <td>{{ classifierBudget.department.value }}</td>
                            <td>{{ classifierBudget.employeeCount ? classifierBudget.employeeCount : 0 }}</td>
                            <td>{{ classifierBudget.budgetSum }} €
                                <small>
                                    {{ classifierBudget.employeeCount ? classifierBudget.budgetSum/classifierBudget.employeeCount : classifierBudget.budgetSum }}€
                                </small>
                            </td>
                            <td>{{ classifierBudget.budgetReserved }} €</td>
                            <td>{{ classifierBudget.budgetUsed }} €</td>
                            <td>{{ classifierBudget.budgetSum }} €</td>
                            <td>
                                <div ng-non-bindable>
                                   <reports-budget-employee></reports-budget-employee>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    `
})
export default class {
    constructor ($rootScope, lodash, moment, DATATABLES, ListFactory, ClassifierBudgetResource, MomentService, DatatableService) {
        this.moment = moment;
        this.ListFactory = ListFactory;
        this.ClassifierBudgetResource = ClassifierBudgetResource;
        this.MomentService = MomentService;
        this.DATATABLES = lodash.merge({}, DATATABLES, DatatableService.getResponsiveOption(([rowIndex]) => {
            const $newScope = $rootScope.$new();
            $newScope.vm = this;
            $newScope.index = rowIndex;
            return $newScope;
        }));
    }

    $onInit () {
        this.defaultFilter = {
            expand: 'department,employeeDepartmentBudgets.user',
            periodStartDate: this.moment().startOf('year').format('YYYY-MM-DD'),
            periodEndDate: this.moment().endOf('year').format('YYYY-MM-DD')
        };

        this.filter = angular.copy(this.defaultFilter);
        this.filter.year = parseInt(this.moment().format('YYYY'), 10);

        this.filterOverview = { };

        this.list = this.ListFactory.createWithoutPagination(this.ClassifierBudgetResource.query.bind(this.ClassifierBudgetResource));
        this.list.fetch(this.defaultFilter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/budget/index.js